import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import MoveIcon from "@common/images/move.svg";
import "./style.scss";

const ENTER_KEY = 13;
/**
 * SlideThreeOption: Option component associated with DesignSection
 * first slide.
 */

export function SlideThreeOption(props) {
  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.addCard(event);

  return (
    <div
      className="slideOption"
      tabIndex="0"
      role="button"
      onKeyDown={onKeyDown}
      onClick={props.addCard}
    >
      <div
        className="slideOption__icon"
        tabIndex={0}
        role="button"
        onClick={props.addCard}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            props.addCard(e);
          }
        }}
        style={{ backgroundColor: props.groupColor }}
      >
        <Image src={MoveIcon} alt="optionIcon" />
      </div>
      <div className="slideOption__text">
        <p>{props.text}</p>
      </div>
    </div>
  );
}

SlideThreeOption.propTypes = {
  /**
   * Function to invoke when SetAsNext Button is clicked
   */
  addCard: PropTypes.func,
  /**
   * SHex value for the group color.
   */
  groupColor: PropTypes.string,
  /**
   * Text to be displayed in Card.
   */
  text: PropTypes.string,
};

SlideThreeOption.defaultProps = {
  groupColor: "#ffffff",
  text: "",
};
